import { render, staticRenderFns } from "./ProductPricingHistoryDialogue.vue?vue&type=template&id=26bcb197&"
import script from "./ProductPricingHistoryDialogue.vue?vue&type=script&lang=ts&"
export * from "./ProductPricingHistoryDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports